var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
import { observable, makeObservable } from 'mobx';
import { runtime } from '../../Runtime';
// uses Network Information Api with polyfill fallback
// https://github.com/daniellmb/downlinkMax
export class BrowserBandwidth {
    parent;
    bandwidthInfoVersion = 0;
    constructor(parent) {
        makeObservable(this);
        this.parent = parent;
        if (navigator.connection) {
            navigator.connection.addEventListener('change', () => runtime.runtimeScheduler.addToNextIdleStateChange(() => this.bandwidthInfoVersion++));
        }
    }
    get downlink() {
        return (this.connection && this.connection.downlink) || 1.55;
    }
    get effectiveType() {
        return (this.connection && this.connection.effectiveType) || '4g';
    }
    get rtt() {
        // roundtrip in ms
        return (this.connection && this.connection.rtt) || 100;
    }
    get connection() {
        return navigator.connection;
    }
    get isFastConnection() {
        return ['4g', '5g'].includes(this.effectiveType);
    }
    get isSlowConnection() {
        return this.effectiveType.includes('2g') || this.effectiveType.includes('3g');
    }
}
__decorate([
    observable
], BrowserBandwidth.prototype, "bandwidthInfoVersion", void 0);
